import Router from "./routes/route";

import './common/css/custom.css';
import './common/css/_boxicons.scss';
import './common/css/responsive.css';


const App = () => {
  return <Router />;
};

export default App;
